/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryBuildingMinPrice
 */

import { MIN_FILTER_PRICE } from '@zcode-ui/filters'
import type { Filters } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'

export const getQueryBuildingMinPrice = ({
  filters,
  price,
}: {
  filters: Partial<Filters> | undefined
  price: number | undefined
}) => {
  const filtersMinPriceIsValid =
    filters && isNumber(filters.minPrice) && filters.minPrice !== MIN_FILTER_PRICE

  if (filtersMinPriceIsValid) {
    return filters.minPrice
  } else if (isNumber(price)) {
    return price
  }

  return null
}
